module.exports = __webpack_public_path__ + "static/media/pm-signup-confirmed.84af9d1e.png";